var m = require('mithril');
var loaders = require('../../layout/components/loaders');
var Model = require('../../libs/Model');
var animations = require('../../libs/animations');
var formGroup = require('../../components/formGroup');
var ToggleSwitch = require('../../components/toggleSwitch');

var host = Object.create(Model);
  
host.name = 'Modbus Tcp';
host.url = 'modbusTcp';
host['@class'] = 'ModbusTcp';
host.fields = {
  name: {
    default: '',
    type: 'string',
    validators: {
      presence : true, 
      length: {minimum: 3, maximum: 128, default: ''},
    }
  },
  host: {
    default: '127.0.0.1',
    type: 'string',
    validators: {
      presence: true,
    }
  },
  port: {
    default: 502,
    type: 'number',
    validators: {
      presence: true,
      numericality: {
        onlyInteger: true,
        greaterThan: 0,
        lessThanOrEqualTo: 65535
      }
    }
  },
  enabled: {
    type: 'switch',
    default: 1,
  }
};

host.initForm();

function isEnabled(value) {
  if (value === true || value === 1) return true;
  if (typeof value === 'string') {
    var normalized = value.trim().toLowerCase();
    return normalized === '1' || normalized === 'true' || normalized === 'yes' || normalized === 'on';
  }
  return false;
}

function enabledField(enabled) {
  return m(formGroup, [
    m('div.flex.items-center.justify-between', [
      m('label', {for:'enabled-input'}, 'Enabled'),
      m(ToggleSwitch, {
        id: 'enabled-input',
        size: 'modal',
        checked: enabled,
        ariaLabel: 'Enabled',
        onchange: function () { host.form.enabled(enabled ? 0 : 1); }
      })
    ])
  ]);
}

host.view = function () { 
  var enabled = isEnabled(host.form.enabled());

  return  m('form', {role:'form'}, [
    host.errorView(),
    enabledField(enabled),
    m(formGroup, [
      m('label', {for:'host-name-input'}, 'Name'),
      m('input.form-control', {
        id:'host-name-input', 
        autocomplete: 'off',
        type:'text', 
        oninput: function(ev){host.form.name(ev.target.value)},
        value: host.form.name(),
      })
    ]),
    m(formGroup, [
      m('label', {for:'host-host-input'}, 'Host'),
      m('input.form-control', {
        id:'host-host-input', 
        autocomplete: 'off',
        type:'text', 
        oninput: function(ev){host.form.host(ev.target.value)}, 
        value: host.form.host(),
      })
    ]),
    m(formGroup, [
      m('label', {for:'host-port-input'}, 'Port'),
      m('input.form-control', {
        id:'host-port-input', 
        autocomplete: 'off',
        type:'text', 
        oninput: function(ev){host.form.port(ev.target.value)}, 
        value: host.form.port(),
      })
    ])
  ])
}

module.exports = host;
